// Class: motion.easing._Quint.QuintEaseOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var QuintEaseOut = function() {
}

// Meta

QuintEaseOut.__name__ = ["motion","easing","_Quint","QuintEaseOut"];
QuintEaseOut.__isInterface__ = false;
QuintEaseOut.__interfaces__ = [(motion_easing_IEasing().default)];
QuintEaseOut.prototype = {
	calculate: function(k) {
		return --k * k * k * k * k + 1;
	},
	ease: function(t,b,c,d) {
		t = t / d - 1;
		return c * (t * t * t * t * t + 1) + b;
	}
};
QuintEaseOut.prototype.__class__ = QuintEaseOut.prototype.constructor = $hxClasses["motion.easing._Quint.QuintEaseOut"] = QuintEaseOut;

// Init



// Statics




// Export

exports.default = QuintEaseOut;